import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';

import * as SlideActions from "../data/slides/SlideActions";

import EditorController from '../controllers/EditorController';
import PlayerController from '../controllers/PlayerController';

class StoryRoute extends React.Component
{
    state = {
        loading: true
    };

    static propTypes = {
        loading: PropTypes.bool.isRequired,
        storyId: PropTypes.string.isRequired,

        listSlides: PropTypes.func.isRequired,
    };

    componentDidMount()
    {
        // @todo shouldn't fetching a single story be complete already?
        // @todo make GET: /story/:id return slides, elements and media!

        this.props.listSlides(this.props.storyId).then(() => {

            // @todo, fetch only the media for a story

            this.setState({loading: false});
        });
    }

    render()
    {
        const loading = this.props.loading || this.state.loading;
        // const loading = true;

        return <>
            <Route exact path="/stories/:storyId">
                <PlayerController loading={loading} storyId={this.props.storyId} />
            </Route>

            <Route exact path="/stories/:storyId/edit">
                <EditorController loading={loading} storyId={this.props.storyId} />
            </Route>
        </>;
    }
}

const mapStateToProps = (state, ownProps) => ({
    storyId: ownProps.match.params.storyId,
});

const mapDispatchToProps = {
    listSlides: SlideActions.listSlides,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StoryRoute);